<template>
  <div>
    <div class="form-container">
      <h1 class="title-three">表3-产品单元划分</h1>
      <div class="message">
        <p>提示：</p>
        <template v-if="showBtn">
          <p>请注意核实产品名称与 表4、表5所填内容是否一致。</p>
          <p>
            评价中心划分检测等级，供应商同时申请检测等级高和检测等级低的分项进行产品质量评价时，按照高级覆盖低级的原则，只收取高
            检测等级的检测费。
          </p>
        </template>

        <p v-if="!showBtn">请注意核实产品名称与表4、表5所填内容是否一致</p>
      </div>
      <div class="radio-outer">
        <div class="radio-item-outer">
          <div class="label">单元分项：</div>
          <div class="radio-item">
            <el-radio-group
              :value="tableObj.evaluationInfo.multiProduct"
              @input="multiProductChange($event)"
            >
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div
          class="radio-item-outer"
          v-if="tableObj.evaluationInfo.multiProduct === 1"
        >
          <div class="label">是否检测等级：</div>
          <div class="radio-item">
            <el-radio-group
              :value="tableObj.evaluationInfo.productMultiLevel"
              @input="productMultiLevelChange($event)"
            >
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div>
        <div class="handle-btn" style="display: flex">
          <!-- <eui-btn type="weak" @click="handleEditDialog(slot.scope.row)">
            导入
          </eui-btn> -->
          <UploadGetData
            :limit="1"
            :fileSize="2"
            :uploadUrl="uploadUrl"
            :verify="true"
            @getFileInfo="getTableThreeInfo"
            :isOnlyXlsx="true"
          />
          <eui-btn type="weak" @click="handleUnitDivisionDown">
            下载模板
          </eui-btn>
          <eui-btn
            type="weak"
            @click="addProduct"
            v-if="
              tableObj.evaluationInfo.multiProduct === 1 &&
              tableObj.evaluationInfo.productMultiLevel === 0
            "
          >
            新增产品名称
          </eui-btn>
        </div>
        <div>
          <ETableList
            :table-data="tableObj.evaluationProductList"
            :table-label="tableLabel"
          >
            <template #level="{ scope }">
              <span>
                {{ `${scope.row.level}级` }}
              </span>
            </template>
            <template #productName="{ scope }">
              <el-input
                v-model="scope.row.productName"
                :disabled="scope.row.addProductPerformance === 1"
                maxlength="200"
                show-word-limit
              ></el-input>
            </template>
            <template #scopeOfApplication="{ scope }">
              <el-input
                v-model="scope.row.scopeOfApplication"
                maxlength="200"
                show-word-limit
              ></el-input>
            </template>
            <template #handle="{ scope }">
              <eui-btn
                v-if="showBtn"
                type="link"
                style="font-size: 12px; color: #0064c8"
                @click="addLevel(scope.row, scope.$index)"
              >
                新增同级
              </eui-btn>
              <eui-btn
                v-if="showBtn"
                style="font-size: 12px; color: #0064c8"
                :class="{ disabled: isAddSubLevelClick(scope.row) }"
                :disabled="isAddSubLevelClick(scope.row)"
                type="link"
                @click="addSubLevel(scope.row, scope.$index)"
              >
                新增子级
              </eui-btn>
              <eui-btn
                v-if="showBtn && scope.$index !== 0 && scope.$index !== 1"
                style="color: #f0250f; font-size: 12px"
                :class="{
                  disabled:
                    isAddSubLevelClick(scope.row) ||
                    tableObj.evaluationProductList.length === 1 ||
                    isEvaluateBtnClick(scope.row),
                }"
                type="link"
                :disabled="
                  isAddSubLevelClick(scope.row) ||
                  tableObj.evaluationProductList.length === 1 ||
                  isEvaluateBtnClick(scope.row)
                "
                @click="handleDelete(scope.row, scope.$index)"
              >
                删除
              </eui-btn>
              <eui-btn
                style="color: #0064c8; font-size: 12px"
                :class="{ disabled: isEvaluateBtnClick(scope.row) }"
                v-if="supplierType !== '103'"
                @click="addEvaluateHandle(scope.row, scope.$index)"
                :disabled="isEvaluateBtnClick(scope.row)"
                type="link"
              >
                添加产品性能评价
              </eui-btn>
              <!-- <eui-btn
                style="color: #0064C8; font-size: 12px"
                type="link"
                @click="addLevel(scope.row, scope.$index)"
                v-if="
                  tableObj.evaluationInfo.multiProduct === 1 &&
                    tableObj.evaluationInfo.productMultiLevel === 0
                "
              >
                新增产品名称
              </eui-btn> -->
              <eui-btn
                style="color: #f0250f; font-size: 12px"
                type="link"
                v-if="
                  !showBtn &&
                  tableObj.evaluationInfo.productMultiLevel === 0 &&
                  scope.$index !== 0 &&
                  scope.$index !== 1
                "
                @click="handleDelete(scope.row, scope.$index)"
              >
                删除
              </eui-btn>
            </template>
          </ETableList>
        </div>
      </div>
    </div>
    <!-- 表4 表5 -->
    <div v-if="supplierType !== '103'">
      <div
        class="form-container"
        v-for="(item, index) in tableObj.evaluationProductPerformanceList"
        :key="index"
      >
        <div class="form-title margin-b20">表4-检测内容和依据</div>
        <div class="handle-btn" style="display: flex">
          <!-- <eui-btn type="weak" @click="handleEditDialog(item, index)">
            {{ `导入表4-${index + 1}` }}
          </eui-btn> -->
          <UploadGetData
            :limit="1"
            :fileSize="2"
            :uploadUrl="productPerformanceImport"
            :verify="true"
            @getFileInfo="getTableFourInfo"
            :isOnlyXlsx="true"
            :index="index + 1"
            :dataFile="{ productName: item.productName, index }"
          />
          <eui-btn type="weak" @click="handlePerformanceEvaluationDown(item)">
            下载模板
          </eui-btn>
        </div>

        <div class="table-4">
          <!-- :style="{item.isShow ?'borderBottom: }"  -->
          <div
            class="table-title-info"
            :style="{
              'border-bottom': !item.isShow ? '1px solid #dcdcdc' : 'none',
            }"
          >
            <div
              class="title-content"
              :style="{
                'margin-bottom':
                  showCover(item.productName).length > 0 ? '10px' : 0,
              }"
            >
              <h2 class="title">
                {{ `表4-${index + 1}${item.productName}检测内容和依据` }}
              </h2>
              <div class="title-handle-btn">
                <!-- && isAddSubLevelClick(item) -->
                <eui-btn
                  type="link"
                  style="font-size: 12px; color: #0064c8"
                  @click="changeCover(item, index)"
                  v-if="showBtn && isAddSubLevelClick(item)"
                >
                  修改覆盖等级
                </eui-btn>
                <eui-btn
                  type="link"
                  style="font-size: 12px; color: #f0250f"
                  @click="deleteFourItem(item, index)"
                >
                  删除本项
                </eui-btn>
                <eui-btn
                  type="link"
                  style="font-size: 12px; color: #0064c8"
                  @click="handleShow(item, index)"
                >
                  {{ !item.isShow ? '展开' : '收起' }}
                  <!-- eicon-arrow-down -->
                  <eui-icon
                    :icon="!item.isShow ? 'eicon-arrow-down' : 'eicon-arrow-up'"
                    color="#0064C8"
                  ></eui-icon>
                </eui-btn>
              </div>
            </div>
            <div
              class="table-info"
              v-if="showCover(item.productName).length > 0"
            >
              <div class="label">覆盖等级：</div>
              <div class="text">
                <span v-for="pName of showCover(item.productName)"
                  >{{ pName.productName }}、</span
                >
                <!-- BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
                001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
                0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
                0012、BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
                001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
                0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
                0012、 -->
              </div>
            </div>
            <!-- <div class="table-info">
              <div class="label">覆盖等级：</div>
              <div class="text">
                BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
                001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
                0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
                0012、BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
                001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
                0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
                0012、
              </div>
            </div> -->
          </div>

          <!--  <transition name="draw"> -->
          <div v-show="item.isShow" ref="showRef">
            <!-- 表4 -->
            <div>
              <div class="table-title-box common-box">
                <div class="first-box">检测项目</div>
                <div class="second-box">技术要求</div>
                <div class="third-box">检测依据</div>
                <div class="fourth-box">备注</div>
                <div class="fifth-box">产品性能评分</div>
                <div class="sixth-box">操作</div>
              </div>
              <div>
                <div
                  v-for="(item1, index1) in item.performanceDetectItemList"
                  :key="index1"
                >
                  <div class="common-box table-content">
                    <div class="first-box">
                      <el-input
                        :disabled="item1.addProductPerformanceBenchmark === 1"
                        v-model="item1.detectItem"
                        placeholder="请输入检测项目"
                        style="padding: 10px"
                        maxlength="200"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div class="second-box">
                      <el-input
                        v-model="item1.techRequirement"
                        placeholder="请输入技术要求"
                        style="padding: 10px"
                        maxlength="200"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div class="third-box">
                      <el-input
                        v-model="item1.reference"
                        placeholder="请输入检测依据"
                        style="padding: 10px"
                        maxlength="200"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div class="fourth-box">
                      <el-input
                        v-model="item1.remark"
                        placeholder="请输入备注"
                        style="padding: 10px"
                        maxlength="200"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div class="fifth-box">
                      <el-checkbox
                        @change="
                          (val) =>
                            checkedChange(val, item, index, item1, index1)
                        "
                        v-model="item1.addProductPerformanceBenchmark"
                        :true-label="1"
                        :false-label="0"
                      ></el-checkbox>
                    </div>
                    <div
                      class="sixth-box"
                      @click="delStandard(index, index1, item)"
                    >
                      <span
                        class="del-box"
                        :style="{
                          color:
                            item.performanceDetectItemList.length === 1
                              ? '#999'
                              : '#F0250F',
                        }"
                      >
                        删除
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-bottom">
                <div class="table-add" @click="addStandard(index)">
                  <eui-icon class="data-icon" icon="eicon-add" />
                  新增检测项目
                </div>
              </div>
            </div>

            <!-- 表5 -->
            <div
              class="table-5"
              v-for="(items, fiveIndexOne) in handleTableFourFive(
                item.productName
              )"
              :key="fiveIndexOne"
            >
              <div class="table-title-info">
                <div class="title-content">
                  <h2 class="title">
                    {{ `表5-${index + 1}${items.productName}产品性能测试表` }}
                  </h2>
                </div>
              </div>
              <div>
                <div
                  v-for="(item1, index1) in items.productBenchmarkItemList"
                  :key="index1"
                >
                  <div class="common-box table-title">
                    <div class="first-item border-right-item">检测项目</div>
                    <div class="first-item border-right-item">备注</div>
                    <div class="second-item border-right-item">分级范围</div>
                    <div class="third-item border-right-item">分值</div>
                    <div class="five-item">操作</div>
                  </div>
                  <div class="handle-box">
                    <div class="handle-left">
                      <div class="first-item">
                        <el-input
                          v-model="item1.scoreName"
                          placeholder="请输入检测项目"
                          style="padding: 10px"
                        ></el-input>
                        <div class="flex-all-center">
                          分值：
                          <!-- <el-input
                            v-model.number="item1.score"
                            placeholder="请输入分值"
                            style="width: 144px;"
                          ></el-input> -->
                          <el-input
                            style="width: 144px"
                            v-model="item1.score"
                            clearable
                            placeholder="请输入分值"
                            @input="
                              item1.score = item1.score.replace(/[^0-9.]/g, '')
                            "
                            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>100)value=100;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                          />
                        </div>
                      </div>
                      <div>
                        <el-input
                          v-model="item1.scoreRemark"
                          placeholder="请输入备注"
                          style="padding: 10px"
                        ></el-input>
                      </div>
                    </div>
                    <div class="handle-right">
                      <div
                        v-for="(
                          item2, index2
                        ) in item1.evaluationProductPerformanceGradeList"
                        :key="index2"
                      >
                        <div class="right-top">
                          <div class="handle-second">
                            <!-- <el-input
                              v-model="item2.gradeRange"
                              placeholder="请输入分级范围"
                              style="padding: 10px"
                              maxlength="200"
                              show-word-limit
                            ></el-input> -->
                            <math-field
                              id="formula"
                              @input="
                                (e) =>
                                  handleMathInput(
                                    e.target.value,
                                    fiveIndexOne,
                                    index1,
                                    index2
                                  )
                              "
                            >
                              {{ item2.gradeRange }}
                            </math-field>
                          </div>
                          <div class="handle-third">
                            <el-input
                              style="padding: 10px"
                              v-model="item2.score"
                              @input="
                                item2.score = item2.score.replace(
                                  /[^0-9.]/g,
                                  ''
                                )
                              "
                              clearable
                              placeholder="请输入分值"
                              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>100)value=100;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                            />
                            <!-- <el-input
                              v-model.number="item2.score"
                              placeholder="请输入分值"
                              style="padding: 10px"
                            ></el-input> -->
                          </div>
                          <div class="handle-five del-box flex-all-center">
                            <div
                              @click="
                                deleteFiveItem(index, index1, index2, items)
                              "
                              :style="{
                                color:
                                  item1.evaluationProductPerformanceGradeList
                                    .length === 1
                                    ? '#999'
                                    : '#F0250F',
                              }"
                              class="margin-r10"
                            >
                              删除
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="add-box">
                        <div
                          class="table-add"
                          @click="addThree(index, fiveIndexOne, index1, items)"
                        >
                          <eui-icon class="data-icon" icon="eicon-add" />
                          分级范围
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </transition> -->
        </div>
      </div>
    </div>

    <div class="form-container" v-if="supplierType === '103'">
      <div class="form-title margin-b20">业务咨询人</div>
      <div class="table-4">
        <div>
          <div class="table-title-box common-box">
            <div class="first-box">业务咨询人</div>
            <div class="second-box">联系方式</div>
            <div class="third-box">邮箱</div>
            <div class="fourth-box">操作</div>
          </div>
          <div>
            <div
              v-for="(item, index) in evaluationBusinessConsultList"
              :key="index"
            >
              <div class="common-box table-content">
                <div class="first-box">
                  <el-input
                    v-model="item.businessConsultName"
                    placeholder="请输入业务咨询人"
                    style="padding: 10px"
                  ></el-input>
                </div>
                <div class="second-box">
                  <el-input
                    v-model="item.businessConsultTel"
                    placeholder="请输入联系方式"
                    style="padding: 10px"
                  ></el-input>
                </div>
                <div class="third-box">
                  <el-input
                    v-model="item.businessConsultEmail"
                    placeholder="请输入邮箱"
                    style="padding: 10px"
                  ></el-input>
                </div>
                <div class="fourth-box" @click="delBusiness(index)">
                  <span
                    class="del-box"
                    :style="{
                      color:
                        evaluationBusinessConsultList.length === 1
                          ? '#999'
                          : '#F0250F',
                    }"
                  >
                    删除
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="table-bottom">
            <div class="table-add" @click="addBusiness">
              <eui-icon class="data-icon" icon="eicon-add" />
              业务咨询人
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-container">
      <div class="form-title margin-b20">抽样规则录入</div>
      <div class="base-detail-box">
        <el-form
          :model="tableObj.evaluationInfo"
          class="demo-form-inline"
          :rules="rules"
          label-width="130px"
          ref="samplingRule"
        >
          <!-- 
          :rules="
                  tempSaveOrConfirmNext === 1
                    ? rules.samplingRule
                    : [{ required: false }]
                "
         -->
          <el-row style="margin-bottom: 0">
            <el-col :span="24" style="margin-bottom: 0">
              <el-form-item
                label="抽样规则录入："
                class="base-detail"
                style="margin-bottom: 0"
                prop="samplingRule"
                required
              >
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="tableObj.evaluationInfo.samplingRule"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="flex-sb" v-if="supplierType === '103'">
      <div>
        <eui-btn type="weak" @click="preStep">上一步</eui-btn>
      </div>
      <div>
        <eui-btn type="secondary" style="margin-right: 10px">预览办法</eui-btn>
        <eui-btn type="secondary" style="margin-right: 10px">预览细则</eui-btn>
        <eui-btn
          type="weak"
          style="margin-right: 10px"
          :disabled="isSaveStep"
          @click="saveStepFour(0)"
        >
          保 存
        </eui-btn>
        <eui-btn type="primary" :disabled="isSaveStep" @click="saveStepFour(1)"
          >提交</eui-btn
        >
      </div>
    </div>

    <div class="flex-sb" v-if="supplierType !== '103'">
      <div>
        <eui-btn type="weak" @click="preStep">上一步</eui-btn>
      </div>
      <div>
        <eui-btn
          type="weak"
          style="margin-right: 10px"
          :disabled="isSaveStep"
          @click="saveStepFour(0)"
        >
          保 存
        </eui-btn>
        <eui-btn type="primary" :disabled="isSaveStep" @click="saveStepFour(1)"
          >下一步</eui-btn
        >
      </div>
    </div>

    <EDialog
      dialogTitle="选择覆盖等级"
      :centerDialogVisible="coverageGradeVisible"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
      :popupWidth="'420px'"
    >
      <el-checkbox-group
        class="checkbox-group"
        v-model="checkedGrades"
        @change="checkedGradesChange"
      >
        <el-checkbox
          v-for="grade in coverageGrades"
          :label="grade.productName"
          :key="grade.productName"
          :disabled="grade.cover === 1"
        >
          {{ grade.productName }}
        </el-checkbox>
      </el-checkbox-group>
    </EDialog>
  </div>
</template>

<script>
import ETableList from '@/modules/projectA/components/common/e-table-list';
import UploadGetData from './uploadGetData.vue';
import Api from '@/modules/projectA/api/ESorganization/index';
import utils from '@/modules/projectA/utils/utils';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import { MathField } from 'mathlive';

// import '//unpkg.com/mathlive';
let mf;
export default {
  props: {
    // 103 没第5步了
    supplierType: {
      type: String,
      default: '',
    },
    evaluationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      mathText: '',
      rules: {
        samplingRule: {
          required: true,
          message: '请输入抽样规则录入',
          trigger: 'blur',
        },
      },
      coverageGradeVisible: false,
      // 是否已被覆盖：1：已被覆盖 0：没被覆盖
      coverageGrades: [
        {
          cover: 0,
          nodeId: '1',
          parentNodeId: '0',
          productName: '111',
        },
      ],
      checkedGrades: [],

      // 添加产品性能评价 后的row数据列表
      evaluateList: [],

      tableLabel: [
        {
          label: '覆盖范围',
          param: 'level',
          align: 'center',
          slot: 'level',
          minWidth: 60,
        },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          minWidth: 120,
          slot: 'productName',
        },
        {
          label: '限制范围',
          param: 'scopeOfApplication',
          align: 'center',
          minWidth: 160,
          slot: 'scopeOfApplication',
        },
        {
          label: '操作',
          align: 'center',
          width: 290,
          slot: 'handle',
        },
      ],

      tableObj: {
        tempSaveOrConfirmNext: 1,
        currentStep: 4, // 步走4
        evaluationCode: 'EQE190102001',
        evaluationId: 1687,
        //
        evaluationInfo: {
          multiProduct: 1,
          productMultiLevel: 0,
          samplingRule: '',
        },
        // 表3
        evaluationProductList: [
          {
            addProductPerformance: 0,
            level: 1,
            nodeId: '1',
            productName: '',
            parentNodeId: '0',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,',
            nodePath: '0,',
          },
          {
            addProductPerformance: 0,
            level: 2,
            nodeId: '1-1',
            productName: '',
            parentNodeId: '1',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,1',
            nodePath: '0,1',
          },
        ],
        // 表4
        evaluationProductPerformanceList: [],
        // 表5
        evaluationProductBenchmarkList: [],
      },
      // 上传表3文件地址
      uploadUrl: '',
      // 表4上传地址
      productPerformanceImport: '',
      // 覆盖等级用
      coverMap: {},
      productName: '',

      evaluationBusinessConsultList: [
        {
          businessConsultEmail: '',
          businessConsultName: '',
          businessConsultTel: '',
        },
      ],
      tempSaveOrConfirmNext: 0,

      isSaveStep: false,
    };
  },
  components: { ETableList, UploadGetData, EDialog, MathField },
  /* watch: {
    'tableObj.evaluationInfo.multiProduct'(newVal) {
      // 单元分项:    tableObj.evaluationInfo.multiProduct 1/0
      // 是否检测等级  tableObj.evaluationInfo.productMultiLevel 1/0
      if (this.tableObj.evaluationInfo.multiProduct === 0) {
        //单元分项 无
        this.$delete(this.tableObj.evaluationInfo, 'productMultiLevel');
        return 10;
      } else {
        this.$set(this.tableObj.evaluationInfo, 'productMultiLevel', 1);
      }
    }
  }, */
  computed: {
    showBtn() {
      return (
        this.tableObj.evaluationInfo.multiProduct === 1 &&
        this.tableObj.evaluationInfo.productMultiLevel === 1
      );
    },
  },
  mounted() {
    this.getStepDetail();
    this.uploadUrl = Api.productUnitPartationImport();
    this.productPerformanceImport = Api.productPerformanceImport();
  },
  methods: {
    handleMathInput(value, fiveIndexOne, index1, index2) {
      console.log(value, fiveIndexOne, index1, index2);
      this.tableObj.evaluationProductBenchmarkList[
        fiveIndexOne
      ].productBenchmarkItemList[index1].evaluationProductPerformanceGradeList[
        index2
      ].gradeRange = value;
      console.log(
        this.tableObj.evaluationProductBenchmarkList[fiveIndexOne]
          .productBenchmarkItemList[index1]
          .evaluationProductPerformanceGradeList[index2]
      );
    },
    limitInput(value, name) {
      this.evaluationInfo[name] =
        ('' + value)
          .replace(/[^\d^\.]+/g, '')
          .replace(/^0+(\d)/, '$1')
          .replace(/^\./, '0.')
          .match(/^\d*(\.?\d{0,2})/g)[0] || '';
    },
    changeMultiProduct(val) {
      this.evaluateList = [];
      if (val === 0) {
        //单元分项 无
        this.tableObj.evaluationInfo.productMultiLevel = 0;
        this.tableObj.evaluationProductList = [
          {
            addProductPerformance: 0,
            level: 1,
            nodeId: '1',
            productName: '',
            parentNodeId: '0',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,',
            nodePath: '0,',
          },
        ];
        this.tableLabel = [
          {
            label: '产品名称',
            param: 'productName',
            align: 'center',
            minWidth: 120,
            slot: 'productName',
          },
          {
            label: '限制范围',
            param: 'scopeOfApplication',
            align: 'center',
            minWidth: 160,
            slot: 'scopeOfApplication',
          },
          {
            label: '操作',
            align: 'center',
            width: 290,
            slot: 'handle',
          },
        ];
        // 表4
        this.tableObj.evaluationProductPerformanceList = [];
        // 表5
        this.tableObj.evaluationProductBenchmarkList = [];
      } else {
        this.tableObj.evaluationInfo.productMultiLevel = 1;
        this.tableObj.evaluationProductList = [
          {
            addProductPerformance: 0,
            level: 1,
            nodeId: '1',
            productName: '',
            parentNodeId: '0',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,',
            nodePath: '0,',
          },
          {
            addProductPerformance: 0,
            level: 2,
            nodeId: '1-1',
            productName: '',
            parentNodeId: '1',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,1',
            nodePath: '0,1',
          },
        ];
        this.tableLabel = [
          {
            label: '覆盖范围',
            param: 'level',
            align: 'center',
            slot: 'level',
            minWidth: 60,
          },
          {
            label: '产品名称',
            param: 'productName',
            align: 'center',
            minWidth: 120,
            slot: 'productName',
          },
          {
            label: '限制范围',
            param: 'scopeOfApplication',
            align: 'center',
            minWidth: 160,
            slot: 'scopeOfApplication',
          },
          {
            label: '操作',
            align: 'center',
            width: 290,
            slot: 'handle',
          },
        ];
      }
    },
    multiProductChange(val) {
      this.$confirm('确定要切换会清空当前数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.tableObj.evaluationInfo.multiProduct = val;
          this.changeMultiProduct(val);
          // 表4
          this.tableObj.evaluationProductPerformanceList = [];
          // 表5
          this.tableObj.evaluationProductBenchmarkList = [];
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    changeProductMultiLevel(val) {
      this.evaluateList = [];
      if (val === 0) {
        this.tableObj.evaluationProductList = [
          {
            addProductPerformance: 0,
            level: 1,
            nodeId: '1',
            productName: '',
            parentNodeId: '0',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0,',
            nodePath: '0,',
          },
          {
            addProductPerformance: 0,
            level: 1,
            nodeId: '2',
            productName: '',
            parentNodeId: '0',
            scopeOfApplication: '',
            sortNum: 0,
            path: '0',
            nodePath: '0',
          },
        ];
        this.tableLabel = [
          {
            label: '产品名称',
            param: 'productName',
            align: 'center',
            minWidth: 120,
            slot: 'productName',
          },
          {
            label: '限制范围',
            param: 'scopeOfApplication',
            align: 'center',
            minWidth: 160,
            slot: 'scopeOfApplication',
          },
          {
            label: '操作',
            align: 'center',
            width: 290,
            slot: 'handle',
          },
        ];
      } else {
        this.tableLabel = [
          {
            label: '覆盖范围',
            param: 'level',
            align: 'center',
            slot: 'level',
            minWidth: 60,
          },
          {
            label: '产品名称',
            param: 'productName',
            align: 'center',
            minWidth: 120,
            slot: 'productName',
          },
          {
            label: '限制范围',
            param: 'scopeOfApplication',
            align: 'center',
            minWidth: 160,
            slot: 'scopeOfApplication',
          },
          {
            label: '操作',
            align: 'center',
            width: 290,
            slot: 'handle',
          },
        ];
      }
      // 表4
      this.tableObj.evaluationProductPerformanceList = [];
      // 表5
      this.tableObj.evaluationProductBenchmarkList = [];
    },
    productMultiLevelChange(val) {
      this.$confirm('确定要切换会清空当前数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.tableObj.evaluationInfo.productMultiLevel = val;
          this.changeProductMultiLevel(val);
          // 表4
          this.tableObj.evaluationProductPerformanceList = [];
          // 表5
          this.tableObj.evaluationProductBenchmarkList = [];
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },

    checkedGradesChange() {
      console.log(this.checkedGrades);
    },
    setResetPopupData() {
      this.coverageGradeVisible = false;
    },
    async setSubmitPopupData() {
      const params = {
        evaluationId: this.evaluationId,
        productName: this.productName,
        coverProductNameList: this.checkedGrades,
      };
      const result = await Api.coverChild(params);
      console.log(result, '覆盖等级');
      if (result.code === '200') {
        this.$message.success('修改覆盖等级成功');
        this.setResetPopupData();
      }
    },

    // 修改覆盖范围接口
    async changeCover(item, index) {
      console.log(item, '修改覆盖范围接口');
      const { nodeId, productName } = item;
      this.productName = productName;
      const params = {
        evaluationId: this.evaluationId,
        nodeId,
        productName,
      };
      const result = await Api.coverOption(params);
      console.log(result, 'result覆盖等级列表');
      if (result.code === '200') {
        this.coverageGrades = [...result.data];
        this.coverageGradeVisible = true;
      }
    },

    treeToArray(tree) {
      return tree.reduce((res, item) => {
        const { children, ...i } = item;
        return res.concat(
          i,
          children && children.length ? this.treeToArray(children) : []
        );
      }, []);
    },
    // 获取表3 导入的信息
    getTableThreeInfo(info) {
      console.log(info, '表3上传数据');
      const result = this.treeToArray(info);
      const allList = [...result, ...this.tableObj.evaluationProductList];
      allList.forEach((item, index) => {
        if (!item.productName && !item.scopeOfApplication) {
          allList.splice(index, 1);
        }
      });
      const deList = this.deArr(allList, 'productName');
      deList.forEach((el) => {
        el.nodePath = el.path;
      });
      this.tableObj.evaluationProductList = [...deList];
      console.log(this.tableObj.evaluationProductList, '导入后表3数据');
    },

    // 获取详情
    async getStepDetail() {
      const result = await Api.stepDetail({
        currentStep: 4,
        evaluationId: this.evaluationId,
      });
      if (result.code === '200') {
        const {
          evaluationProductList = [],
          evaluationProductPerformanceList = [],
          evaluationProductBenchmarkList = [],
          evaluationInfo = {},
          coverMap = {},
        } = result.data;
        // evaluationInfo 处理
        if (
          evaluationInfo.productMultiLevel !== 0 &&
          evaluationInfo.productMultiLevel !== 1
        ) {
          evaluationInfo.productMultiLevel = 0;
        }
        if (
          evaluationInfo.multiProduct !== 0 &&
          evaluationInfo.multiProduct !== 1
        ) {
          evaluationInfo.multiProduct = 1;
        }

        if (evaluationInfo.multiProduct === 0) {
          evaluationInfo.productMultiLevel = 0;
        }

        if (!evaluationInfo.samplingRule) {
          evaluationInfo.samplingRule = '';
        }

        this.changeMultiProduct(evaluationInfo.multiProduct);
        if (evaluationInfo.multiProduct !== 0) {
          this.changeProductMultiLevel(evaluationInfo.productMultiLevel);
        }

        /* evaluationInfo.multiProduct = 1;
        evaluationInfo.productMultiLevel = 0;
        this.changeMultiProduct(evaluationInfo.multiProduct);
        if (evaluationInfo.multiProduct !== 0) {
          this.changeProductMultiLevel(evaluationInfo.productMultiLevel);
        } */

        console.log(this.tableObj, 'this.tableObjthis.tableObj 前');

        // 表4 展开收起
        evaluationProductPerformanceList.forEach((item) => {
          item.isShow = true;
          // 联动表3 添加产品性能评价按钮
          this.evaluateList.push(item.nodeId);
        });
        // this.evaluateList.push(row.nodeId);
        console.log(evaluationProductList, 'evaluationProductList详情表3');

        this.tableObj = {
          evaluationProductList: this.tableObj.evaluationProductList,
          ...result.data,
          evaluationProductPerformanceList,
          evaluationProductBenchmarkList,
          evaluationInfo,
        };
        this.coverMap = { ...coverMap };
      }
      console.log(this.tableObj, 'this.tableObj this.tableObj ');
    },
    // ---------
    // 表3 新增同级
    addLevel(row, index) {
      // 获取当前nodeId 通过 - 分割后的 length
      const rowNodeIdLength = row.nodeId.split('-').length;
      const itemObj = {
        level: '',
        nodeId: '',
        parentNodeId: 0,
        productName: '',
        scopeOfApplication: '',
        key: '',
        sortNum: index + 1,
        addProductPerformance: 0,
      };
      console.log(itemObj.sortNum, '同级');
      let level = rowNodeIdLength;

      const filterArr = this.tableObj.evaluationProductList.filter((item) => {
        return item.nodeId.split('-').length === rowNodeIdLength;
      });

      const nodeIds = filterArr.map((item) => {
        const nodeIdArr = item.nodeId.split('-');
        return Number(nodeIdArr[nodeIdArr.length - 1]);
      });
      // 同级 parentNodeId 是相同的
      const maxNodeId = Math.max(...nodeIds);
      if (rowNodeIdLength > 1) {
        itemObj.parentNodeId = row.parentNodeId;
        itemObj.nodeId = `${itemObj.parentNodeId}-${maxNodeId + 1}`;
      } else {
        itemObj.nodeId = `${maxNodeId + 1}`;
        itemObj.parentNodeId = '0';
      }

      itemObj.level = level;
      this.tableObj.evaluationProductList.push(itemObj);
      console.log(itemObj, '同级');
      console.log(this.tableObj.evaluationProductList);
    },
    addProduct() {
      const nodeId = this.tableObj.evaluationProductList.length + 1;
      const itemObj = {
        level: '',
        nodeId,
        parentNodeId: 0,
        productName: '',
        scopeOfApplication: '',
        key: '',
        sortNum: nodeId,
        addProductPerformance: 0,
      };
      this.tableObj.evaluationProductList.push(itemObj);
      console.log(this.tableObj.evaluationProductList);
    },
    // 表3 新增子级
    addSubLevel(row, index) {
      const rowNodeIdList = row.nodeId.split('-');
      const rowNodeIdLength = rowNodeIdList.length;
      const pathList = ['0'];
      let pathString = '';
      rowNodeIdList.forEach((item, index) => {
        pathString += `-${item}`;
        if (pathString.startsWith('-')) {
          pathString = pathString.slice(1);
        }
        pathList.push(pathString);
      });
      const path = pathList.join(',') + ',';
      console.log(pathList, 'pathList', path);
      const itemObj = {
        level: '',
        nodeId: '',
        parentNodeId: '',
        productName: '',
        scopeOfApplication: '',
        sortNum: index + 1,
        addProductPerformance: 0,
        path,
        nodePath: path,
      };
      console.log(itemObj.sortNum, '自己');
      let level = rowNodeIdLength;

      const filterArr = this.tableObj.evaluationProductList.filter((item) => {
        return item.nodeId.split('-').length === rowNodeIdLength;
      });
      const isNodeId = filterArr.some((item) =>
        item.nodeId.startsWith(`${item.nodeId}-`)
      );
      if (isNodeId) {
        const nodeIds = filterArr.map((item) => {
          const nodeIdArr = item.nodeId.split('-');
          return Number(nodeIdArr[nodeIdArr.length - 1]);
        });
        const maxNodeId = Math.max(...nodeIds);
        itemObj.parentNodeId = row.nodeId;
        itemObj.nodeId = `${itemObj.parentNodeId}-${maxNodeId + 1}`;
        itemObj.level = level;
        this.tableObj.evaluationProductList.push(itemObj);
      } else {
        const nodeIds = filterArr.map((item) => {
          const nodeIdArr = item.nodeId.split('-');
          level = nodeIdArr.length + 1;
          return Number(nodeIdArr[nodeIdArr.length - 1]);
        });
        const maxNodeId = Math.max(...nodeIds);
        itemObj.parentNodeId = row.nodeId;
        itemObj.nodeId = `${itemObj.parentNodeId}-${maxNodeId + 1}`;
        itemObj.level = level;
        this.tableObj.evaluationProductList.push(itemObj);
      }
    },
    // 表3 判断 新增子级 按钮是否可点击
    isAddSubLevelClick(row) {
      const isDisabled = this.tableObj.evaluationProductList.some((item) =>
        item.nodeId.startsWith(`${row.nodeId}-`)
      );
      return isDisabled;
    },
    // 表3 删除功能
    async handleDelete(row, index) {
      const { nodeId = '', productName = '' } = row;
      const params = {
        evaluationId: this.evaluationId,
        nodeId,
        productName,
      };
      const result = await Api.deleteProduct(params);
      if (result.code === '200') {
        this.tableObj.evaluationProductList.splice(index, 1);
      }
    },

    // 判断产品名称出现的次数
    getArrItemNum(arr) {
      let obj = {};
      arr.forEach((element) => {
        console.log(element.productName, 'element.productName');
        if (obj[element.productName]) {
          obj[element.productName]++;
        } else {
          obj[element.productName] = 1;
        }
      });
      return obj;
    },

    // 表3 添加产品性能评价 操作
    async addEvaluateHandle(row, index) {
      if (!row.productName) {
        return this.$message.warning('请填写产品名称');
      }
      if (!row.scopeOfApplication) {
        return this.$message.warning('请填写限制范围');
      }
      // 判断 产品名称是否重复
      const oNumber = this.getArrItemNum(this.tableObj.evaluationProductList)[
        row.productName
      ];
      console.log(oNumber, 'oNumber');
      if (oNumber > 1) {
        return this.$message.warning('产品名称有重复, 请检查');
      }

      /*
        "evaluationId": 0,
        "nodeId": "string",
        "parentNodeId": "string",
        "path": "string",
        "productName": "string"
      */
      const { nodeId, parentNodeId, nodePath = '0,', productName } = row;
      const params = {
        nodeId,
        parentNodeId,
        path: nodePath,
        productName,
        evaluationId: this.evaluationId,
      };
      const result = await Api.addProductPerformance(params);
      if (result.code === '200') {
        row.addProductPerformance = 1;
        this.evaluateList.push(row.nodeId);
        // 联动表4
        const productName = row.productName;
        const table4ItemObj = {
          productName,
          nodeId: row.nodeId,
          isShow: true,
          performanceDetectItemList: [
            {
              addProductPerformanceBenchmark: 0,
              detectItem: '',
              techRequirement: '',
              reference: '',
              remark: '',
              sortNum: index,
            },
          ],
        };
        this.tableObj.evaluationProductPerformanceList.push(table4ItemObj);
        console.log(this.tableObj.evaluationProductList, '表3');
      }
    },

    // 表3 判断 添加产品性能评价 按钮是否可点击
    isEvaluateBtnClick(row) {
      console.log(this.evaluateList, row.nodeId);
      // this.evaluateList.includes(row.nodeId);
      // console.log(this.evaluateList.includes(row.nodeId), 'isEvaluateBtnDisabled');
      return this.evaluateList.includes(row.nodeId);
    },
    // -------------------------------
    // 表4 删除整个表
    async deleteFourItem(item, index) {
      console.log(item, index);
      const { productName = '' } = item;
      const result = await Api.deleteProductPerformance({
        evaluationId: this.evaluationId,
        productName,
      });
      if (result.code === '200') {
        // 删除的试试把表3对应项的 addProductPerformance 字段置为0
        const findIndex = this.tableObj.evaluationProductList.findIndex(
          (el) => el.nodeId === item.nodeId // 这个可能随时改动 后面都是根据nodeId来判断的
          // el => el.productName === item.productName
        );
        this.tableObj.evaluationProductList[
          findIndex
        ].addProductPerformance = 0;

        // 删除表4
        //console.log(item.nodeId, 'nodeId');
        //console.log(this.evaluateList, 'this.evaluateList');
        const evaluateIndex = this.evaluateList.findIndex(
          (el) => el === item.nodeId
        );
        //console.log(evaluateIndex, 'evaluateIndex');
        this.evaluateList.splice(evaluateIndex, 1);
        this.tableObj.evaluationProductPerformanceList.splice(index, 1);
        // 删除表5
        const filterArr = this.tableObj.evaluationProductBenchmarkList.filter(
          (el) => el.productName !== item.productName
        );
        this.tableObj.evaluationProductBenchmarkList = [...filterArr];
      }
    },
    // 表4 新增检测项目
    addStandard(index) {
      const itemObj = {
        addProductPerformanceBenchmark: '',
        detectItem: '',
        techRequirement: '',
        reference: '',
        remark: '',
        sortNum: index,
      };
      console.log(this.tableObj.evaluationProductPerformanceList);
      this.tableObj.evaluationProductPerformanceList[
        index
      ].performanceDetectItemList.push(itemObj);
    },
    // 表4 下面列表删除
    delStandard(index, index1, item) {
      console.log(index, index1);
      console.log(index, this.tableObj.evaluationProductPerformanceList);
      if (
        this.tableObj.evaluationProductPerformanceList[index]
          .performanceDetectItemList.length === 1
      ) {
        return false;
      }
      this.tableObj.evaluationProductPerformanceList[
        index
      ].performanceDetectItemList.splice(index1, 1);
      this.tableObj.evaluationProductBenchmarkList.splice(index1, 1);
    },
    // 表4 产品性能评分 生成表5 与 删除表5
    checkedChange(val, item, index, item1, index1) {
      console.log(val, item, index, item1, index1);
      console.log(item.productName, item1.detectItem, 'detectItem');
      // item.performanceDetectItemList[index].addProductPerformanceBenchmark = val;
      console.log('标记:', index, index1);
      const flag = `${index}-${index1}`;
      // item.performanceDetectItemList[index1].flag = flag;
      const tableFiveItem = {
        flag,
        productName: item.productName,
        productBenchmarkItemList: [
          {
            // detectItem: '', // item1.detectItem
            detectItem: item1.detectItem,
            score: '', // 分数
            scoreName: '',
            scoreRemark: '',
            evaluationProductPerformanceGradeList: [
              {
                gradeRange: '',
                score: '',
                sortNum: index,
              },
            ],
          },
        ],
      };
      // 表4 没有检测项目不能添加 产品性能评分
      if (!item1.detectItem) {
        item1.addProductPerformanceBenchmark = 0;
        return this.$message.warning('请输入表4检测项目');
      }

      if (val) {
        this.tableObj.evaluationProductBenchmarkList.push(tableFiveItem);
      } else {
        const findIndex =
          this.tableObj.evaluationProductBenchmarkList.findIndex(
            (item) => item.flag === flag
          );
        console.log(findIndex, 'findIndex');
        this.tableObj.evaluationProductBenchmarkList.splice(findIndex, 1);
      }
    },

    // 表4展开收起
    handleShow(item, index) {
      console.log(item, index);
      item.isShow = !item.isShow;
    },
    showCover(productName) {
      return this.coverMap[productName] || [];
    },
    // ----------
    // 处理表5数据
    handleTableFourFive(productName) {
      const filterFiveList =
        this.tableObj.evaluationProductBenchmarkList.filter(
          (item) => item.productName === productName
        );
      return filterFiveList;
    },

    // 表5 新增
    addThree(index, fiveIndexOne, index1, items) {
      console.log(items);
      const findIndex = this.tableObj.evaluationProductBenchmarkList.findIndex(
        (item) => item.flag === items.flag
      );

      console.log(findIndex);
      const fiveObj = {
        gradeRange: '',
        score: '',
        sortNum: '',
      };
      this.tableObj.evaluationProductBenchmarkList[
        findIndex
      ].productBenchmarkItemList[
        index1
      ].evaluationProductPerformanceGradeList.push(fiveObj);
    },

    // 表5删除
    deleteFiveItem(index, index1, index2, items) {
      // 一个不能删除
      const findIndex = this.tableObj.evaluationProductBenchmarkList.findIndex(
        (item) => item.flag === items.flag
      );

      if (
        this.tableObj.evaluationProductBenchmarkList[findIndex]
          .productBenchmarkItemList[index1]
          .evaluationProductPerformanceGradeList.length === 1
      ) {
        return;
      }
      this.tableObj.evaluationProductBenchmarkList[
        findIndex
      ].productBenchmarkItemList[
        index1
      ].evaluationProductPerformanceGradeList.splice(index2, 1);
    },

    // 保存
    async saveStepFour(tempSaveOrConfirmNext) {
      this.tempSaveOrConfirmNext = tempSaveOrConfirmNext;
      if (this.supplierType !== '103' && tempSaveOrConfirmNext === 1) {
        // 提交校验表3/4/5没填项 提示语: 表3/4/5产品信息填写不完
        for (let i = 0; i < this.tableObj.evaluationProductList.length; i++) {
          const el = this.tableObj.evaluationProductList[i];
          if (!el.productName || !el.scopeOfApplication) {
            return this.$message.warning('表3产品信息填写不完整');
          }
          if (el.addProductPerformance !== 1) {
            return this.$message.warning('表3还有未生成产品性能评价的产品单元');
          }
        }

        // 表4
        for (
          let i = 0;
          i < this.tableObj.evaluationProductPerformanceList.length;
          i++
        ) {
          const el = this.tableObj.evaluationProductPerformanceList[i];
          for (let j = 0; j < el.performanceDetectItemList.length; j++) {
            const item = el.performanceDetectItemList[j];
            if (!item.detectItem || !item.techRequirement || !item.reference) {
              return this.$message.warning('表4产品信息填写不完整');
            }

            let warnIndex = 1;
            const flag = el.performanceDetectItemList.some(
              (iten, itenIndex) => {
                console.log(itenIndex, 'itenIndex');
                warnIndex = itenIndex + 1;
                return iten.addProductPerformanceBenchmark === 1;
              }
            );
            console.log(i, 'i');
            if (!flag) {
              return this.$message.warning(
                `表4-${i + 1}至少选择一项是否产品性能评分`
              );
            }
          }
        }

        // 表5 使用这种方式 来阻止
        try {
          this.tableObj.evaluationProductBenchmarkList.forEach((el) => {
            el.productBenchmarkItemList.forEach((item) => {
              item.evaluationProductPerformanceGradeList.forEach((iten) => {
                if (!iten.gradeRange || !iten.score || !iten.score === '0') {
                  // return this.$message.warning('表5产品信息填写不完整');
                  throw new Error('return');
                }
              });
            });
          });
        } catch (err) {
          return this.$message.warning('表5产品信息填写不完整或者分值为0');
        }
      }
      /* this.$nextTick(() => {
        this.$refs['samplingRule'].validate(async valid => {
          if (valid) {
            try {
              // v-if="supplierType !== '103'"
              this.isSaveStep = true;
              const result = await Api.tempSaveOrConfirmNext({
                ...this.tableObj,
                tempSaveOrConfirmNext,
                currentStep: 4,
                supplierType: this.supplierType,
                evaluationBusinessConsultList:
                  this.supplierType === '103' ? this.evaluationBusinessConsultList : [],
              });
              if (result.code === '200') {
                this.$message.success('操作成功');
                if (this.supplierType === '103') {
                  this.$router.push({ path: '/ES/ESorganization' });
                } else {
                  if (tempSaveOrConfirmNext === 1) {
                    this.$emit('getStep', 5);
                  }
                }
              }
            } finally {
              this.isSaveStep = false;
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }); */
      // v-if="supplierType !== '103'"
      try {
        // v-if="supplierType !== '103'"
        this.isSaveStep = true;
        const result = await Api.tempSaveOrConfirmNext({
          ...this.tableObj,
          tempSaveOrConfirmNext,
          currentStep: 4,
          supplierType: this.supplierType,
          evaluationBusinessConsultList:
            this.supplierType === '103'
              ? this.evaluationBusinessConsultList
              : [],
        });
        if (result.code === '200') {
          this.$message.success('操作成功');
          if (this.supplierType === '103') {
            this.$router.push({ path: '/ES/ESorganization' });
          } else {
            if (tempSaveOrConfirmNext === 1) {
              this.$emit('getStep', 5);
            }
          }
        }
      } finally {
        this.isSaveStep = false;
      }
    },
    // 表3 下载
    async handleUnitDivisionDown() {
      const result = await Api.unitDivisionDown();
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        utils.downFile(result, '表3');
      }
    },

    preStep() {
      this.$emit('getStep', 3);
    },

    // 表4 下载
    async handlePerformanceEvaluationDown(row) {
      console.log(row, 'row');
      const { productName = '' } = row;
      const result = await Api.performanceEvaluationDown({ productName });
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        utils.downFile(result, '表4');
      }
    },

    deArr(arr, attr) {
      const obj = {};
      const newArr = arr.reduce(function (item, next) {
        obj[next[attr]] ? '' : (obj[next[attr]] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },

    // 表4 导入
    getTableFourInfo(info, index) {
      console.log(info, index, '表4');
      const {
        evaluationProductBenchmarkList = [],
        evaluationProductPerformanceList = [],
      } = info;
      // 表4 evaluationProductPerformanceList
      evaluationProductPerformanceList.forEach((item) => {
        item.isShow = true;
      });
      const evaluationProductPerformanceArr = [
        ...evaluationProductPerformanceList,
        ...this.tableObj.evaluationProductPerformanceList,
      ];
      const newEvaluationProductPerformanceList = this.deArr(
        evaluationProductPerformanceArr,
        'productName'
      );
      this.tableObj.evaluationProductPerformanceList = [
        ...newEvaluationProductPerformanceList,
      ];
      console.log(this.tableObj.evaluationProductPerformanceList, '表4导入后');
      //

      const evaluationProductBenchmarkArr = [
        ...evaluationProductBenchmarkList,
        ...this.tableObj.evaluationProductBenchmarkList,
      ];

      const newEvaluationProductBenchmarkList = this.deArr(
        evaluationProductBenchmarkArr,
        'productName'
      );
      this.tableObj.evaluationProductBenchmarkList = [
        ...newEvaluationProductBenchmarkList,
      ];
    },

    addBusiness() {
      const item = {
        businessConsultEmail: '',
        businessConsultName: '',
        businessConsultTel: '',
      };
      this.evaluationBusinessConsultList.push(item);
      console.log(this.evaluationBusinessConsultList);
    },
    delBusiness(index) {
      if (this.evaluationBusinessConsultList.length === 1) {
        return false;
      }
      this.evaluationBusinessConsultList.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.base-detail-box {
  ::v-deep .el-form-item__error {
    display: none;
  }
}

.disabled {
  ::v-deep .btn_eui_box {
    color: #666;
  }
}
.checkbox-group {
  display: flex;
  flex-direction: column;
  .el-checkbox {
    margin-bottom: 12px;
    ::v-deep .el-checkbox__input {
      .el-checkbox__inner {
        width: 18px;
        height: 18px;
        border-radius: 0;
        &::after {
          height: 8px;
          left: 5px;
          top: 2px;
        }
      }
    }
  }
}

.draw-enter-active,
.draw-leave-active {
  transition: all 1s ease;
}

.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}

.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 100% */
}
.radio-outer {
  margin-top: 20px;
  display: flex;
  .radio-item-outer {
    flex: 1;
    display: flex;
    align-items: center;
    .label {
      font-size: 14px;
      margin-right: 10px;
    }
    ::v-deep .el-radio {
      .el-radio__inner {
        width: 18px;
        height: 18px;
        &::after {
          width: 6px;
          height: 6px;
        }
      }
    }
  }
}
.handle-btn {
  margin: 20px 0 10px 0;
}

.form-container {
  color: $c3;
  .message {
    margin-top: 20px;
    padding: 15px 0px 15px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-weight: 350;
  }
  .table-4 {
    .table-title-info {
      padding: 13px 10px 13px 20px;
      border: 1px solid #dcdcdc;
      border-bottom: none;
      background: #f5f5f5;
      .title-content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .title {
          color: #333;
          font-size: 14px;
          font-weight: 500;
          line-height: 1;
        }
        .title-handle-btn {
          display: flex;
          font-size: 12px;
          .table-handle-btn {
            margin-right: 10px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .table-info {
        display: flex;
        color: #666;
        font-size: 14px;
        .label {
          font-weight: 350;
          white-space: nowrap;
        }
      }
    }
    .common-box {
      width: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      border: 1px solid #dcdcdc;
      border-bottom: none;
      font-size: 12px;
      color: #333;
      font-weight: bold;
      .first-box {
        flex: 1;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .second-box {
        flex: 1;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .third-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .fourth-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .fifth-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .sixth-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        // border-right: 1px solid #dcdcdc;
      }
    }
    .table-title-box {
      height: 40px;
      background-color: #f5f5f5;
    }
    .table-content {
      height: 50px;
      .del-box {
        color: #0064c8;
        cursor: pointer;
        font-size: 12px;
      }
    }
    .table-bottom {
      height: 60px;
      padding: 10px;
      background-color: #f5f5f5;
      border: 1px solid #dcdcdc;
      .data-icon {
        width: 10px;
        height: 10px;
        margin-right: 10px;
      }
      .table-add {
        cursor: pointer;
        background-color: #fff;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .table-5 {
    margin-top: 20px;
    .table-title-info {
      padding: 13px 10px 13px 20px;
      border: 1px solid #dcdcdc;
      background: #f5f5f5;
      .title-content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .title {
          color: #333;
          font-size: 14px;
          font-weight: 500;
          line-height: 1;
        }
      }
    }
    .production-review-box {
      width: 100%;
      padding: 10px;
      border: 1px solid #dcdcdc;
      background-color: #f5f5f5;
      margin-top: 10px;

      .production-review-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .production-review-left {
          color: #666;
          font-size: 12px;

          .project-box {
            width: 160px;
          }
        }

        .production-review-right {
          font-size: 14px;
          color: #0064c8;

          .show-box {
            cursor: pointer;
            color: #0064c8;

            .data-icon {
              width: 14px;
              height: 14px;
            }
          }
        }
      }

      .production-review-bottom {
        margin-top: 4px;
        font-size: 12px;
        color: #f0250f;
      }
    }
    .common-box {
      display: flex;
      text-align: center;
      // align-items: center;
      font-size: 12px;
      border: 1px solid #dcdcdc;
      height: 40px;
      background-color: #f5f5f5;
      border-top: none;
      border-bottom: none;
      color: #333;

      .border-right-item {
        // height: calc(100% - 1px);
        line-height: 40px;
        display: flex;
        // align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }

      .first-item {
        width: 200px;
      }

      .second-item {
        flex: 2;
      }

      .third-item {
        flex: 1;
      }

      .four-item {
        width: 60px;
      }

      .five-item {
        width: 80px;
        line-height: 40px;
      }
    }

    .handle-box {
      display: flex;
      text-align: center;
      font-size: 12px;
      border: 1px solid #dcdcdc;

      .handle-left {
        width: 400px;
        align-self: stretch;
        display: flex;
        border-right: 1px solid #dcdcdc;
        .first-item {
          border-right: 1px solid #dcdcdc;
        }
        & > div {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }

      .handle-right {
        width: calc(100% - 400px);
        overflow: hidden;
        // border-left: 1px solid #dcdcdc;

        .right-top {
          display: flex;
          height: 50px;
          border-bottom: 1px solid #dcdcdc;

          .handle-second {
            flex: 2;
            border-right: 1px solid #dcdcdc;
            overflow: hidden;
            #formula {
              position: relative;
              /* height: 100%; */
              margin: 7px;
              width: calc(100% - 14px);
              &::part(content) {
                overflow: visible;
              }
            }
          }

          .handle-third {
            flex: 1;
            // border-left: 1px solid #dcdcdc;
          }

          .handle-four {
            width: 60px;
            border-left: 1px solid #dcdcdc;
          }

          .handle-five {
            width: 81px;
            line-height: 50px;
            border-left: 1px solid #dcdcdc;
          }

          .del-box {
            color: #0064c8;
            cursor: pointer;
            font-size: 12px;
          }
        }
      }
    }

    .add-box {
      height: 60px;
      padding: 10px;
      background-color: #f5f5f5;

      .data-icon {
        width: 10px;
        height: 10px;
        margin-right: 10px;
      }

      .table-add {
        font-size: 16px;
        cursor: pointer;
        background-color: #fff;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .title-three {
    margin-bottom: 20px;
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }
  .form-item {
    display: flex;
    .form-item-label {
      white-space: nowrap;
    }
    .form-item-content {
      flex: 1;
    }
  }
  ::v-deep .el-input__suffix {
    right: 15px;
    font-weight: normal;
  }
}
</style>
